import {
  GET_TEMPLATES_REQUEST,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAILED,
  ENTER_SUPPORT_CONTEXT,
  LEAVE_SUPPORT_CONTEXT,
} from "../constant";

const initial = {
  templates: [],
  isTemplatesLoading: false,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
};

export const templateReducer = (state = initial, action) => {
  switch (action.type) {
    case ENTER_SUPPORT_CONTEXT:
    case LEAVE_SUPPORT_CONTEXT:
      // Never show one tenant's rows while another tenant's are loading.
      return { ...initial };
    case GET_TEMPLATES_REQUEST:
      return {
        ...state,
        isTemplatesLoading: true,
      };
    case GET_TEMPLATES_SUCCESS: {
      const payload = action.payload;
      const raw = payload.content ?? payload.templates ?? [];
      const templates = Array.isArray(raw)
        ? raw.map((t) => ({ ...t, id: t.id ?? t._id }))
        : [];
      const pagination = payload.pagination ?? state.pagination;
      return {
        ...state,
        isTemplatesLoading: false,
        templates,
        pagination,
      };
    }
    case GET_TEMPLATES_FAILED:
      return {
        ...state,
        isTemplatesLoading: false,
      };
    default:
      return state;
  }
};
